import Component from 'inferno-component';
import './BalloonGame.css';

const stringKnotPosition = { x: 60, y: 120 };

class BalloonGame extends Component {
  constructor(props) {
    super(props);
    this.state = {
      balloonCount: 3,
      fallingSpeed: 0,
      isPopped1: false,
      isPopped2: false,
      isPopped3: false
    };
  }

  componentDidMount() {
    this.updateStrings();
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(this.tick);
    }
  }

  updateStrings = ()=> {
    if (!this.state.isPopped1) {
      this.drawString(this.balloon1, stringKnotPosition, this.string1);
    }

    if (!this.state.isPopped2) {
      this.drawString(this.balloon2, stringKnotPosition, this.string2);
    }

    if (!this.state.isPopped3) {
      this.drawString(this.balloon3, stringKnotPosition, this.string3);
    }
  }

  drawString(src, dest, targ) {
    let size = src.offsetWidth;
    let srcTransform = (window.getComputedStyle(src, null).transform || '').split(', ');

    if (srcTransform.length >= 6) {
      let srcTransformX = parseFloat(srcTransform[4]);
      let srcTransformY = parseFloat(srcTransform[5]);
      let x1 = src.offsetLeft + srcTransformX + size / 2;
      let y1 = src.offsetTop + srcTransformY + size;
      let x2 = dest.x;
      let y2 = dest.y;
      let adjX = 30;
      let adjY = 20;
      targ.setAttribute('d', 'M' + x1 + ' ' + y1 + ' C ' + x1 + ' ' + (y1 + adjY) + ', ' + (x2 - adjX) + ' ' + y2 + ', ' + x2 + ' ' + y2);
    }
  }

  componentWillReceiveProps(nextProps) {

  }

  tick = ()=> {
    this.updateStrings();
    window.requestAnimationFrame(this.tick);
  }

  flagPopped = (index)=> {
    let newState = {};
    newState['isPopped' + index] = true;
    this.setState(newState);
  }

  popBalloon = (index)=> {
    let balloon = this['balloon' + index];
    let string = this['string' + index];
    balloon.classList.add('pop');
    this.flagPopped(index);

    setTimeout(()=> {
      balloon.classList.remove('pop');
      balloon.classList.add('popped');
      string.classList.add('popped');
      let remainingBalloonCount = this.state.balloonCount - 1;
      this.setState({ balloonCount: remainingBalloonCount});
      if (remainingBalloonCount === 0) {
        document.body.classList.add('no-more-balloons')
      }
    }, 300);
  }

  overBalloon(i) {

  }

  outBalloon(i) {

  }

  render() {
    return (
      <div className="balloon-game">
        <div className="character" ref={(el)=> { this.character = el; }}>
          <svg className="canvas" ref={(el)=> { this.canvas = el; }}>
            <path className="string string-1" ref={(el)=> { this.string1 = el; }}></path>
            <path className="string string-2" ref={(el)=> { this.string2 = el; }}></path>
            <path className="string string-3" ref={(el)=> { this.string3 = el; }}></path>
          </svg>
          <div className="balloon balloon-1" ref={(el)=> { this.balloon1 = el; }} onClick={()=> { this.popBalloon(1); }} onMouseOver={()=> { this.overBalloon(1); }} onMouseOut={()=> { this.outBalloon(1); }}></div>
          <div className="balloon balloon-2" ref={(el)=> { this.balloon2 = el; }} onClick={()=> { this.popBalloon(2); }} onMouseOver={()=> { this.overBalloon(2); }} onMouseOut={()=> { this.outBalloon(2); }}></div>
          <div className="balloon balloon-3" ref={(el)=> { this.balloon3 = el; }} onClick={()=> { this.popBalloon(3); }} onMouseOver={()=> { this.overBalloon(3); }} onMouseOut={()=> { this.outBalloon(3); }}></div>
        </div>
        <div className="trampoline"></div>
      </div>
    );
  }
}

export default BalloonGame;



// WEBPACK FOOTER //
// ./src/BalloonGame/BalloonGame.js